export default __webpack_public_path__ + "static/media/airstrapz-blk-4.23f7336b.png";